import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DefaultTheme } from "@styles";

export const PurchaseDeliveryDate = styled.h4`
  ${({ theme }) => {
    const { typography, colors } = theme as DefaultTheme;

    return css`
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: ${typography.smallFontSize};
      margin-bottom: 16px;
      padding: 12px;
      background-color: ${colors.successGreen};
    `;
  }}
`;
